module.exports = __webpack_public_path__ + "static/img/banner_1.db042943.png";